'use client';

import { useState, useEffect } from 'react';
import { FullPageSpinner } from './ui/loading-spinner';

interface ClientOnlyProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

export default function ClientOnly({ 
  children, 
  fallback = (
    <div className="fixed inset-0 flex items-center justify-center bg-background/80 backdrop-blur-sm z-50">
      <div className="h-16 w-16 animate-spin rounded-full border-4 border-solid border-current border-r-transparent" />
    </div>
  ) 
}: ClientOnlyProps) {
  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    setHasMounted(true);
  }, []);

  if (!hasMounted) {
    return fallback;
  }

  return <>{children}</>;
}